<template>
  <div class="bg">
    <div class="content">
      <div class="container">
        <span>©2016 Emulian.com All Rights Reserved</span>
        <span> | </span>
        <span>京ICP备16013545号-1</span>
      </div>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'homeRights'
  }
</script>

<style scoped>
  div.bg {
    display: flex;
  }
  div.content {
    background-color: rgb(242, 242, 242);
    width: 1100px;
    margin:auto;
    display: flex;
    align-items: center;
  }
  div.container{
    width: auto;
    padding: 0;
    margin: auto;
    margin-top: 10px;
    padding-bottom: 30px;
    text-align: center;
  }
  span {
    color: rgb(73,73,73);
    text-align: center;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// HomeRights.vue?2355d3a0